import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getIsAvailableOpportunity } from '@swf/core/models/sports/utils/betSlip/getIsOpportunity';
import { select } from '@swf/core/store';
import type { MultipleOpportunity, SingleOpportunity } from '@swf/generated/types/api/sports';
import { haveOddsChanged } from '@swf/sports/utils/updateMarket';

/**
 * Monitors odds changes for single opportunity
 */
const useOpportunityOddsChanges = (opportunity: SingleOpportunity | MultipleOpportunity) => {
  const acceptedOdds = useSelector(select.betSlip.acceptedOdds);
  const opportunityAcceptedOdds = useMemo(
    () => acceptedOdds[opportunity.id],
    [acceptedOdds, opportunity.id]
  );

  return {
    haveOddsChanged: Boolean(
      getIsAvailableOpportunity(opportunity) &&
        opportunityAcceptedOdds &&
        haveOddsChanged(opportunity.winRunnerOdds, opportunityAcceptedOdds)
    ),
    acceptedOdds: opportunityAcceptedOdds
  };
};

export default useOpportunityOddsChanges;
